import styled from 'styled-components';

import { MOBILE_PADDING, PAGE_WIDTH, WHITE } from '../../../styles/variables.style';
import media from '../../../styles/media.style';

export const Section = styled.section`
  background-color: #1f2125;
  margin: 0 auto;
  max-width: ${PAGE_WIDTH}px;
  position: relative;
  width: 100%;

  ${media.tabletL`
    background-position: 0 0;
    background-size: contain;
    margin: 0 auto;
  `};
`;

export const SectionInner = styled.div`
  width: 100%;

  ${media.tabletL`
    align-items: center;
    display: flex;
  `};
`;

export const ContentWrapper = styled.div`
  background-color: black;
  color: ${WHITE};
  padding: 45px ${MOBILE_PADDING}px;
  text-align: center;

  ${media.tabletL`
    background-color: unset;
    padding: 0 40px;
    text-align: left;
    width: 45%;
  `};
`;

export const Title = styled.h1`
  font-size: 30px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${WHITE};

  > span {
    font-weight: 600;
  }

  ${media.tabletL`
    font-size: 44px;
    max-width: 400px;
  `};

  ${media.desktop`
    font-size: 54px;
  `};
`;

export const Text = styled.p`
  margin-bottom: 2em;

  > span {
    font-weight: 400;
  }

  ${media.tabletL`
    margin-bottom: 1em;
    max-width: 400px;
  `};

  h1,
  h2,
  h3,
  p {
    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  h1 {
    font-size: 22px;
  }

  h2 {
    font-size: 20px;
  }

  h3 {
    font-size: 18px;
  }

  p {
    font-size: 14px;
    white-space: pre-line;

    ${media.tabletP`
      font-size: 16px;
    `};

    ${media.tabletL`
      font-size: 18px;
      line-height: 1.39;
      letter-spacing: 0.1px;
    `};
  }
`;



// WEBPACK FOOTER //
// ./src/pages/EducationPage/EducationHero/EducationHero.style.js